/**
 * Pure date utility functions for Gantt chart
 */
import { addMinutes } from 'date-fns';
import { isoDateFormat } from 'helpers/utils';

export const parseDate = (dateValue) => {
	if (!dateValue) return null;

	// Handle UTC dates from backend - add 'Z' if not present to ensure UTC interpretation
	// The browser will automatically convert to local time
	if (typeof dateValue === 'string') {
		const dateWithZ = dateValue[dateValue.length - 1] === 'Z'
			? dateValue
			: dateValue + 'Z';
		const date = new Date(dateWithZ);
		return isNaN(date.getTime()) ? null : date;
	}

	const date = new Date(dateValue);
	return isNaN(date.getTime()) ? null : date;
};

export const calculateEndDate = (startDate, estimatedMinutes) => {
	if (!startDate || !estimatedMinutes) return startDate;
	const start = parseDate(startDate);
	if (!start) return null;
	return addMinutes(start, estimatedMinutes);
};

export const calculateDateRange = (tasks) => {
	if (!tasks || tasks.length === 0) {
		return { start: null, end: null };
	}

	let earliestStart = null;
	let latestEnd = null;

	tasks.forEach((task) => {
		if (task.start) {
			const taskStart = new Date(task.start);
			if (!earliestStart || taskStart < earliestStart) {
				earliestStart = taskStart;
			}
		}
		if (task.end) {
			const taskEnd = new Date(task.end);
			if (!latestEnd || taskEnd > latestEnd) {
				latestEnd = taskEnd;
			}
		}
	});

	return { start: earliestStart, end: latestEnd };
};

export const formatDateForInput = (dateString) => {
	if (!dateString) return '';
	try {
		let date;
		if (dateString.includes('T')) {
			date = new Date(dateString);
		} else {
			const dateWithZ = dateString[dateString.length - 1] === "Z"
				? dateString
				: dateString + "Z";
			const isoDate = isoDateFormat(dateWithZ);
			date = new Date(isoDate);
		}
		
		if (isNaN(date.getTime())) {
			console.warn('Invalid date:', dateString);
			return '';
		}
		
		return date.toISOString().slice(0, 16);
	} catch (error) {
		console.warn('Error formatting date:', dateString, error);
		return '';
	}
};